export default __webpack_public_path__ + "static/media/SWT0190.34I-27411_-16473_0.57615a5d.jpg";